import React, { useId, useState } from "react";
import "./FAQ.css";
import { ChevronDownIcon } from "./public/icons";

// Accessible accordion item used by the help center and pricing page. It keeps
// a real button (not a <details>) so the expanded state is announced and the
// answer stays out of the tab order while collapsed.
const FAQ = ({ question, answer, defaultOpen = false, variant }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <div
      className={`faq-item${isOpen ? " is-open" : ""}${variant ? ` faq-item--${variant}` : ""}`}
    >
      <button
        type="button"
        className="faq-toggle"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span className="faq-question">{question}</span>
        <ChevronDownIcon size={17} className="faq-chev" />
      </button>
      <div className="faq-answer" id={panelId} hidden={!isOpen}>
        {answer}
      </div>
    </div>
  );
};

export default FAQ;
